import { render, staticRenderFns } from "./ArtistAvatar.vue?vue&type=template&id=11646cac&scoped=true&"
import script from "./ArtistAvatar.vue?vue&type=script&lang=js&"
export * from "./ArtistAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ArtistAvatar.vue?vue&type=style&index=0&id=11646cac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11646cac",
  null
  
)

export default component.exports